<template>
  <div>
    <div style="margin-bottom: 10px;">
      <el-button size="mini" type="primary" @click="pageChange(1)">查询</el-button>
      <el-button size="mini" style="margin-left: 10px;color: #606266;" @click="exportExcel">导出明细</el-button>
      <router-link to="/order/order/orderAdjust">
        <el-button size="mini" style="margin-left: 10px;color: #606266;">应收费用调整(流程)</el-button>
      </router-link>
      <router-link to="/order/order/orderPaymentFlow">
        <el-button size="mini" style="margin-left: 10px;color: #606266;" >系统欠费减免流程</el-button>
      </router-link>
      <router-link to="/order/order/orderRedFlushFlow">
        <el-button size="mini" style="margin-left: 10px;color: #606266;">账单红冲(流程)</el-button>
      </router-link>
    </div>
    <div style="margin-bottom: 10px;">
      <el-descriptions title="" :column="2" border size="mini" label-style="width: 100px" content-style="calc(45% - 200px)">
        <el-descriptions-item label="主房产">
          <el-autocomplete
            style="min-width: 400px;max-width: 100%"
            v-model="mainObj.house_name"
            :fetch-suggestions="querySearchAsyncRoom"
            @select="handleSelect"
            @clear="handleCancel"
            placeholder="请输入房产"
            popper-class="autocomplete-room"
            clearable
          ></el-autocomplete>
        </el-descriptions-item>
        <el-descriptions-item label="状态">
          <el-select v-model="where.status" size="mini" placeholder="请选择状态" @change="pageChange(1)">
            <el-option label="全部" value=""></el-option>
            <el-option label="待审" value="0"></el-option>
            <el-option label="审核中" value="1"></el-option>
            <el-option label="已审批" value="2"></el-option>
          </el-select>
        </el-descriptions-item>
        <el-descriptions-item label="旧业主">
          <el-input v-model="where.old_customer" size="mini" placeholder="请输入旧业主" style="width: 400px;" @change="pageChange(1)"></el-input>
        </el-descriptions-item>
        <el-descriptions-item label="新业主">
          <el-input v-model="where.new_customer" size="mini" placeholder="请输入新业主" style="width: 400px;" @change="pageChange(1)"></el-input>
        </el-descriptions-item>
      </el-descriptions>
    </div>
    <el-table :data="pageData.data" style="width: 100%" border height="50vh">
      <el-table-column prop="id" label="ID" width="80"></el-table-column>
      <el-table-column prop="house_name" label="房产" width="320"></el-table-column>
      <el-table-column prop="old_customer" label="旧业主" width="320"></el-table-column>
      <el-table-column prop="new_customer" label="新业主" width="320"></el-table-column>
      <el-table-column prop="billing_cut_off_date" label="账单结转日期" width="100"></el-table-column>
      <el-table-column prop="file_id" label="文件" width="80">
        <template slot-scope="scope">
          <el-link type="primary" @click="$refs.viewFileListRef.show(scope.row.file_id)" v-if="scope.row.file_id>0">查看</el-link>
        </template>
      </el-table-column>
      <el-table-column prop="task_id" label="流程" width="80">
        <template slot-scope="scope">
          <el-link type="primary" v-if="scope.row.task_id>0" @click="$refs.viewFlowRef.show({task_id:scope.row.task_id,batchNumber:scope.row.batch_number})" :data-task_id="scope.row.task_id" :data-batch_number="scope.row.batch_number">查看</el-link>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态" width="80">
        <template slot-scope="scope">
          <span v-if="scope.row.status===0">待审</span>
          <span v-else-if="scope.row.status===1">审核中</span>
          <span v-else-if="scope.row.status===2">已审批</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" min-width="280" fixed="right">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="startFlow([scope.row],1)" v-if="scope.row.task_id===0">结清流程</el-button>
          <el-button type="primary" size="mini" @click="startFlow([scope.row],0)" v-if="scope.row.task_id===0">未结清流程</el-button>
          <el-button type="danger" size="mini" @click="deleteFlow(scope.row.id)" v-if="scope.row.task_id===0">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div style="margin-top: 20px;text-align: center;display: flex;justify-content: center;align-items: center;">
      <el-input v-model="pageData.per_page" placeholder="每页显示条数" @change="pageChange(1)" style="width: 80px;" size="mini"></el-input>
      <Page :total="pageData.total" :current-page="pageData.current_page" :page-size="pageData.per_page" @on-change="pageChange" show-total />
    </div>

    <ViewFileList ref="viewFileListRef" />
    <ViewFlow ref="viewFlowRef" />
  </div>
</template>

<script>
import ViewFileList from "../../Common/ViewFileList";
import ViewFlow from "../../Common/ViewFlow";
export default {
  name: "CustomerSaleList",
  components: {ViewFlow, ViewFileList},
  inject:['mainObj','componentId','setComponentId','commonObj'],
  data() {
    return {
      where:{
        status:'',
        old_customer:'',
        new_customer:''
      },
      pageData:{
        total: 0,
        per_page: 20,
        current_page: 0,
        last_page: 0,
        data: []
      }
    };
  },
  mounted() {
    this.pageChange(1)
  },
  methods: {
    getList(){
      const that = this;
      ERP.getRequest({
        url: 'admin/HouseSaleFlow/getList',
        data:{
          project_id:that.mainObj.project_id,
          house_id:that.commonObj.house_id,
          page: that.pageData.current_page,
          per_page: that.pageData.per_page,
          ...that.where
        }
      }, (res) => {
        if(res.code){
          this.pageData = res.data;
        }
      })
    },
    pageChange(page){
      const that = this;
      that.pageData.current_page = page;
      that.getList();
    },
    startFlow(list=[],type_model=1){
      const that = this;
      let s_count = list.length;
      if(type_model===1){
        let item = list[0];
        ERP.postRequest({
          url: 'admin/HouseSaleFlow/isExists',
          data:{
            project_id:item.project_id,
            house_id:item.house_id,
            old_customer_id:item.old_customer_id,
            billing_cut_off_date:item.billing_cut_off_date,
          }
        }, (res) => {
          if(res.code){
            ERP.postRequest({
              url: 'admin/HouseSaleFlow/getBatchNumber',
              data:{
                ids: list.map(ret=>ret.id).join(',')
              }
            }, (resp) => {
              if(resp.code){
                let timeValue=(new Date()).getTime()
                let zhuan_rang_lei_xing=type_model?'结清转让':'未结清转让';
                ERP.navigateTo(`/flow/FlowView?sheet_id=275&master_id=223&batch_number=${resp.data}&s_count=${s_count}&zhuan_rang_lei_xing=${zhuan_rang_lei_xing}&timeValue=${timeValue}`)
              }else {
                that.$message.error(resp.msg);
              }
            })
          }else {
            this.$alert(res.msg);
          }
        })
      }else {
        ERP.postRequest({
          url: 'admin/HouseSaleFlow/getBatchNumber',
          data:{
            ids: list.map(ret=>ret.id).join(',')
          }
        }, (res) => {
          if(res.code){
            let timeValue=(new Date()).getTime()
            let zhuan_rang_lei_xing=type_model?'结清转让':'未结清转让';
            ERP.navigateTo(`/flow/FlowView?sheet_id=275&master_id=223&batch_number=${res.data}&s_count=${s_count}&zhuan_rang_lei_xing=${zhuan_rang_lei_xing}&timeValue=${timeValue}`)
          }else {
            that.$message.error(resp.msg);
          }
        })
      }
    },
    deleteFlow(id){
      const that = this;
      that.$confirm('确认删除该条记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        ERP.postRequest({
          url: 'admin/HouseSaleFlow/delete',
          data:{
            id: id
          }
        }, (res) => {
          if(res.code){
            that.pageChange(that.pageData.current_page);
          }
        })
      }).catch(() => {
        that.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    querySearchAsyncRoom(queryString, cb){
      if(!queryString){
        cb([]);
      }else {
        ERP.postRequest({
          url:"admin/Customer/getHouseList",
          data:{keyWord:queryString}
        },ret=>{
          if(ret.code) {
            cb(ret.data)
          }
        })
      }
    },
    handleSelect(item) {
      this.commonObj.house_id=item.id;
      this.mainObj.house_id=item.id;
      this.mainObj.house_name=item.value;
      this.pageChange(1);
    },
    handleCancel() {
      this.commonObj.house_id=0;
      this.mainObj.house_id=0;
      this.mainObj.house_name='';
      this.pageChange(1);
    },
    exportExcel(){
      const that = this;
      ERP.postRequest({
        url: 'admin/HouseSaleFlow/exportExcel',
        data:{
          project_id:that.mainObj.project_id,
          house_id:that.commonObj.house_id,
          page: that.pageData.current_page,
          per_page: that.pageData.per_page,
          ...that.where
        }
      }, (res) => {
        if(res.code){
          window.open(res.data)
        }else {
          that.$message.error(res.msg);
        }
      })
    },
  },
  watch:{
    "mainObj.project_id":function(val){
      this.pageData.current_page = 1;
      this.getList();
    },
    "commonObj.house_id":function(val){
      this.pageData.current_page = 1;
      this.getList();
    }
  }
}
</script>

<style lang="scss" scoped>
@import "common";
</style>



// WEBPACK FOOTER //
// src/components/Admin/User/CustomerManagement/CustomerSaleList.vue